<template>
  <div class="contact">
    <div class="contact__container">
      <h1 class="contact__container--p">سوالات متداول</h1>
      <div class="contact__container--info">
        <div
          class="colapsible-container"
          :key="(item, index)"
          v-for="(item, index) in cola"
        >
          <button class="collapsible" @click="opclo">
            {{ item.question }}
            <font-awesome-icon class="collapsible-svg" icon="angle-down" />
          </button>
          <div class="content">
            <p class="content-p" v-html="item.answer"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      per: true,
      cola: [],
      isActive: false,
      info: {
        name: "",
        email: "",
        pho: "",
        text: "",
      },
    };
  },
  mounted() {
    // var coll = document.getElementsByClassName("collapsible");
    // var i = 0;
    // for (i = 0; i < coll.length; i++) {
    //   coll[i].addEventListener("click", function() {
    //     this.classList.toggle("active");
    //     var content = this.nextElementSibling;
    //     if (content.style.maxHeight) {
    //       content.style.maxHeight = null;
    //     } else {
    //       content.style.maxHeight = content.scrollHeight + "px";
    //     }
    //   });
    // }
  },
  methods: {
    opclo(e) {
      var coll = document.getElementsByClassName("collapsible");
      // console.log(e.target.firstElementChild.classList);
      var i = 0;
      this.isActive = !this.isActive;
      //   for (i = 0; i < coll.length; i++) {
      //   coll[i].addEventListener("click", function() {
      // e.target.toggle("active");
      e.target.classList.toggle("active");
      e.target.firstElementChild.classList.toggle("svgA");
      var content = e.target.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
      // });
      //   }
    },
    send() {
      function validateEmail(email) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }
      var that = this;
      this.$store.state.load = true;
      if (
        this.info.name.length == 0 ||
        this.info.text.length == 0 ||
        this.info.email.length == 0
      ) {
        that.$toastr.e("لطفا فیلد های مشخص شده را پر کنید.");
        that.$store.state.load = false;
      } else if (this.info.name.length > 63) {
        that.$toastr.e("نام وارد شده بیشتر از حد مجاز است.");
        that.$store.state.load = false;
      } else if (!validateEmail(this.info.email)) {
        that.$toastr.e("لطفا ایمیل معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.info.pho < 11 && this.info.pho != 0) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/contact/create/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          //   headers: {
          //     Authorization: "Bearer" + " " + sessionStorage.getItem("profile")
          //   },
          type: "POST",
          data: {
            name: this.info.name,
            email: this.info.email,
            cellphone: this.info.pho,
            message: this.info.text,
          },
          success: function (data, textStatus, request) {
            that.$toastr.s(data);
          },
          error: function (request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function () {
            that.$store.state.load = false;
            that.info.name = "";
            that.info.text = "";
            that.info.email = "";
          },
        });
      }
    },
  },
  created() {
    var that = this;
    this.$store.state.load = true;
    $.ajax({
      url: that.$store.state.url + "api/v1/pages/faq/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        that.cola = data;
        // console.log(data);
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
  },
};
</script>
<style lang="scss" scoped>
.j1 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    // width: 93%;
    background: red;
    @media screen and (max-width: 500px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j2 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    // width: 96%;
    // background: red;
    // background: red;
    @media screen and (max-width: 500px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j3 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    direction: rtl !important;
    // width: 98%;
    // background: red;
    @media screen and (max-width: 500px) {
      width: 93%;
      font-size: 0.8em;
    }
  }
}
.contact {
  width: 100%;
  height: auto;
  // background: red;
  margin-top: 7.9em;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
    font-size: 0.6em;
  }
  &__container {
    display: flex;
    flex-direction: column;
    direction: rtl;
    padding: 3em;
    justify-content: center;
    // align-items: center;
    // background: red;
    width: 80%;
    @media screen and (max-width: 1000px) {
      width: 100%;
    }
    @media screen and (max-width: 500px) {
      margin-top: 5em;
      width: 100%;
    }
    &-btn {
      text-decoration: none;
      border: none;
      padding: 1em;
      color: var(--main-color);
      background: var(--sub-color);
      font-family: "yekan";
      margin-top: 2em;
      border-radius: 8px;
      cursor: pointer;
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      // transform: translate(5.5%);
    }
    &--p {
      font-family: 0.9em;
      margin-bottom: 1em;
    }
    &--info {
      direction: rtl;
      border-radius: 8px;
      background: var(--main-color);
      border: 1px solid rgb(194, 214, 219);
      height: auto;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.164);
      display: flex;
      flex-direction: column;
      padding: 1em;
      padding: 4em;
      &-text {
        width: 97%;
        color: var(--font-color);
        font-family: "yekan";
        // width: auto;
        border: none;
        background: var(--bg-color);
        padding: 1em;
        margin: 1em;
        border-radius: 8px;
        direction: rtl;
        resize: none;
      }
      &-fname {
        width: 50%;
      }
      &-lname {
        width: 50%;
      }
    }
  }
}
.con7 {
  //   background: red;
  width: 100%;
  display: flex;
}
.edit {
  background: var(--main-color) !important;
  border: 1px solid var(--sub-color) !important;
}
.collapsible {
  direction: rtl;
  background-color: var(--shrink);
  color: var(--font-color);
  cursor: pointer;
  padding: 20px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 18px;
  background: linear-gradient(
    180deg,
    rgba(245, 245, 245, 1) 100%,
    rgb(255, 255, 255) 0%
  );
  text-align: right;
  font-family: "lalezar";
  @media screen and (max-width: 700px) {
    font-size: 0.9em;
  }
  @media screen and (max-width: 500px) {
    font-size: 1.1em;
  }
  &-svg {
    float: left;
    // color: red;
    // text-align: left;
    // align-self: flex-start;
    transition: all 0.2s ease-out;
    color: var(--shrink);
    margin-top: 0.3em;
    transform: rotate(0deg); /* Equal to rotateZ(45deg) */
  }
}

.collapsible:hover {
  direction: rtl;
  //   background-color: var(--sub-color);
}
.active {
  background: rgb(245, 245, 245);
  background: linear-gradient(
    180deg,
    rgba(245, 245, 245, 1) 90%,
    rgb(255, 255, 255) 100%
  );
}
.colapsible-container {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-bottom: 1em;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.05);
}
.content {
  @media screen and (max-width: 700px) {
    font-size: 0.9em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.9em;
  }
  direction: rtl;
  font-family: "yekan";
  padding: 0px 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  //   line-height: 20px;
  background-color: var(--main-color);
  &-p {
    margin: 1em 0;
  }
}
.svgA {
  transform: rotate(180deg); /* Equal to rotateZ(45deg) */
  transition: all 0.2s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/components/QA/question.vue